import styled, { css } from 'styled-components'
import FlexRow from '../FlexRow'
import Text from '../Text'
import Icon from '../Icon'

interface SensitiveSpanProps {
  title?: string
  visible?: boolean
}

interface SensitiveIconProps {
  visible?: boolean
}

export const SensitiveSpan = styled.span<SensitiveSpanProps>`
  ${({ visible, theme }) =>
    !visible &&
    css`
      align-items: center;
      position: relative;
      background: ${theme.colors.lightGrey};
      cursor: pointer;
      border-radius: 3px;
      padding: 8px 12px;
      letter-spacing: 2px;
      white-space: nowrap;
      overflow: hidden;

      &,
      > span {
        display: inline-flex;
      }
    `};
`

export const MaskLabel = styled(Text.Span).attrs({
  light: true,
})`
  position: relative;
  top: 3px;
`

// @ts-ignore
export const SensitiveIcon = styled(Icon).attrs(({ visible }) => ({
  button: true,
  name: visible ? 'icon-sensitive-off' : 'icon-sensitive-on',
}))<SensitiveIconProps>`
  &&&& {
    top: -2px;
    margin-right: 0;
    margin-left: 4px;
  }
`

export const ChildrenWrapper = styled(FlexRow).attrs({
  noMargin: true,
  justifyContent: 'flex-start',
  alignItems: 'center',
})`
  ${SensitiveIcon} {
    opacity: 0;
  }

  :hover ${SensitiveIcon} {
    opacity: 1;
  }
`
